var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 33C7.175 33 6.469 32.7116 5.882 32.1349C5.294 31.5573 5 30.8632 5 30.0526V13.8421C5 13.0316 5.294 12.338 5.882 11.7613C6.469 11.1836 7.175 10.8947 8 10.8947H14V7.94737C14 7.13684 14.294 6.44274 14.882 5.86505C15.469 5.28835 16.175 5 17 5H23C23.825 5 24.5315 5.28835 25.1195 5.86505C25.7065 6.44274 26 7.13684 26 7.94737V10.8947H32C32.825 10.8947 33.5315 11.1836 34.1195 11.7613C34.7065 12.338 35 13.0316 35 13.8421V30.0526C35 30.8632 34.7065 31.5573 34.1195 32.1349C33.5315 32.7116 32.825 33 32 33H8ZM17 10.8947H23V7.94737H17V10.8947ZM8 30.0526H32V13.8421H8V30.0526ZM8 30.0526V13.8421V30.0526Z",
    fill: "#004B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelCompany);
export default __webpack_public_path__ + "static/media/panel-company.ad428febcdab62e2db5228652de3b144.svg";
export { ForwardRef as ReactComponent };